module.exports = __webpack_public_path__ + "img/instagram-story.fcb15628.svg";